import React, { useState } from 'react';
import Modal from './Modal';
import './DeleteAccountModal.css';
interface DeleteAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isDeleting?: boolean;
}
const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isDeleting = false 
}) => {
  const [confirmText, setConfirmText] = useState('');
  const isConfirmValid = confirmText === 'DELETE';
  const handleConfirm = async () => {
    if (isConfirmValid && !isDeleting) {
      await onConfirm();
    }
  };
  const handleClose = () => {
    if (!isDeleting) {
      setConfirmText('');
      onClose();
    }
  };
  const customFooter = (
    <div className="delete-account-actions">
      <button
        type="button"
        className="delete-account-cancel-button"
        onClick={handleClose}
        disabled={isDeleting}
      >
        Cancelar
      </button>
      <button
        type="button"
        className="delete-account-confirm-button"
        onClick={handleConfirm}
        disabled={!isConfirmValid || isDeleting}
      >
        {isDeleting ? 'Eliminando...' : 'Eliminar Cuenta Permanentemente'}
      </button>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Eliminar Cuenta" customFooter={customFooter}>
      <div className="delete-account-modal-content">
        <div className="delete-account-warning">
          <svg 
            width="48" 
            height="48" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            className="delete-account-warning-icon"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <h3>¿Estás seguro de que deseas eliminar tu cuenta?</h3>
          <p>
            Esta acción <strong>no se puede revertir</strong>. Se eliminarán permanentemente:
          </p>
          <ul>
            <li>Tu cuenta de usuario</li>
            <li>Tu perfil personal</li>
            <li>Tu perfil institucional (si aplica)</li>
          </ul>
          <p className="delete-account-final-warning">
            <strong>Esta acción es permanente e irreversible.</strong>
          </p>
        </div>
        <div className="delete-account-confirm-section">
          <label htmlFor="delete-confirm-input" className="delete-account-label">
            Para confirmar, escribe <strong>DELETE</strong>:
          </label>
          <input
            id="delete-confirm-input"
            type="text"
            className="delete-account-input"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value.toUpperCase())}
            placeholder="DELETE"
            disabled={isDeleting}
            autoComplete="off"
            style={{ textTransform: 'uppercase' }}
          />
        </div>
      </div>
    </Modal>
  );
};
export default DeleteAccountModal;
